export const RecipeDetail = {
  bindings: {
    recipe: '<',
    isFavourite: '<',
    onFavourite: '&',
    onClickVariation: '&',
  },

  template: `
    <div class="row">
      <div class="col-md-8">
        <recipe-options
          serves="$ctrl.recipe.serves"
          variations="$ctrl.recipe.variations"
          prep-time="$ctrl.recipe.prepTimeMins"
          cooking-time="$ctrl.recipe.cookingTimeMins"
          calories="$ctrl.recipe.caloriesPerServe"
          is-marinated="$ctrl.recipe.marinatingRequired"
          on-click-variation="$ctrl.onClickVariation({ recipeId: recipeId })">
        </recipe-options>
        <div class="img-wrapper d-block d-md-none">
          <favourite-button
            is-favourite="$ctrl.isFavourite"
            ng-click="$ctrl.onFavourite()"
            ng-if="$ctrl.isFavourite !== undefined">
          </favourite-button>
          <img class="img-fluid"
            ng-src="{{ $ctrl.recipe.imageUrl.large | assetSrc }}"
            ng-if="$ctrl.recipe.imageUrl" />
          <img class="img-fluid"
            ng-src="{{ $ctrl.recipe.image.large | assetSrc }}"
            ng-if="$ctrl.recipe.image" />
        </div>
        <section class="pt-3" ng-show="$ctrl.recipe.summary">
          <p ng-bind="$ctrl.recipe.summary"></p>
        </section>
        <section class="pt-3">
          <h5>Ingredients</h5>
          <ingredients-list
            ingredients="$ctrl.recipe.ingredientsList">
          </ingredients-list>
        </section>
        <section class="pt-3">
          <h5>Method</h5>
          <div ng-bind-html="$ctrl.recipe.cookingMethodHtml"></div>
        </section>
        <section
          ng-if="$ctrl.recipe.mishTipsHtml">
          <h5>Coaching Zone Tips</h5>
          <div ng-bind-html="$ctrl.recipe.mishTipsHtml"></div>
        </section>
        <div class="my-5"
          ng-if="$ctrl.recipe.id">
          <reviews
            wording-plural="Reviews"
            wording-rating="Rate this Recipe"
            wording-singular="Review"
            reviewable-type="Recipe"
            reviewable-id="$ctrl.recipe.id">
          </reviews>
        </div>
      </div>
      <div class="col-md-4">
        <div class="img-wrapper d-none d-md-block">
          <favourite-button
            is-favourite="$ctrl.isFavourite"
            ng-click="$ctrl.onFavourite()"
            ng-if="$ctrl.isFavourite !== undefined">
          </favourite-button>
          <img class="img-fluid"
            ng-src="{{ $ctrl.recipe.imageUrl.large | assetSrc }}"
            ng-if="$ctrl.recipe.imageUrl" />
          <img class="img-fluid"
            ng-src="{{ $ctrl.recipe.image.large | assetSrc }}"
            ng-if="$ctrl.recipe.image" />
          </div>
        <div class="small text-gray my-3">
          <p>
            Image serve size is indicative only. Follow your recipe
            serving size instructions and method.
          </p>
          <p>
            All recipes are written for conventional ovens. If you have a
            fan-forced oven, please decrease the stated temperature by
            20&deg;C.
          </p>
        </div>
        <nutrition-information
          data="$ctrl.recipe.nutritionSummary"
          serves="$ctrl.recipe.serves">
        </nutrition-information>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Recipe/RecipeDetail.js